/** Slot-rhythm value shape + defaults (Campaigns/Sessions v2 #5).
 * Kept separate from the component so fast-refresh stays happy and the
 * wizard + settings step share one source of truth. */
export type SlotSettings = {
  slot_minutes: number;
  break_minutes: number;
  slack_minutes: number;
  break_mode: "none" | "after_n_calls" | "after_minutes";
  calls_before_break: number;
  minutes_before_break: number;
  long_break_minutes: number;
};

export const DEFAULT_SLOT_SETTINGS: SlotSettings = {
  slot_minutes: 15,
  break_minutes: 10,
  slack_minutes: 0,
  break_mode: "after_n_calls",
  calls_before_break: 4,
  minutes_before_break: 90,
  long_break_minutes: 30,
};
